import { Component } from '@angular/core';
import { Size, ErrorState, LabelPosition, ExtThemes, ButtonKind, WidthState } from '@usitsdasdesign/dds-ng/shared';
import { InputModule, InputOptions, DescriptionType, TextAlign } from '@usitsdasdesign/dds-ng/input';
import { ReactiveFormsModule, FormControl } from "@angular/forms";
import { TextareaModule, TextareaOptions } from '@usitsdasdesign/dds-ng/textarea';
import { ButtonModule, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { Router } from '@angular/router';
import { ProjectsService } from '../core/services/projects.service';

@Component({
  selector: 'app-project-create',
  standalone: true,
  imports: [
    ButtonModule,
    InputModule,
    TextareaModule,
    ReactiveFormsModule,
  ],
  templateUrl: './project-create.component.html',
  styleUrl: './project-create.component.scss'
})
export class ProjectCreateComponent {
  constructor(
    private router: Router,
    private projectService: ProjectsService,
  ) { }

  inputFormCtrl = new FormControl({ value: '', disabled: false });

  inputOptions: InputOptions = {
    label: 'Project name',
    labelPosition: LabelPosition.external,
    placeholder: '',
    isError: false,
    isRequired: true,
    isInverse: false,
    size: Size.md,
    description: '',
    descriptionType: DescriptionType.text,
    errorMessage: '',
    errorState: ErrorState.default,
    textAlign: TextAlign.left,
    type: 'text',
  };

  changeValue() {
  }

  onBlur() {
  }

  textareaFormCtrl = new FormControl({ value: '', disabled: false });

  textareaOptions: TextareaOptions = {
    label: 'Description',
    labelPosition: LabelPosition.external,
    placeholder: '',
    minHeight: 250,
    isRequired: false,
    isInverse: false,
    readonly: false,
    isError: true,
    errorState: ErrorState.default,
    description: '',
    errorMessage: '',
    size: Size.md
  };

  descriptionValueChanged() {
    console.log("descriptionValueChanged", this.textareaFormCtrl.value);
  }

  createButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primaryLoud,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: 'dds-icon_plus',
    isIconLeft: false,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Create project',
    customClass: '',
    role: 'button'
  }

  createProjectClick(event: Event): void {
    this.projectService.createProject({
      name: this.inputFormCtrl.value ?? '',
      description: this.textareaFormCtrl.value ?? ''
    }).subscribe(e => {
      console.log(e);
      this.router.navigate(['projects']);
    });

  }

  cancelButtonOptions: ButtonOptions = {
    theme: ExtThemes.green,
    kind: ButtonKind.primary,
    size: Size.md,
    width: WidthState.fixed,
    isLoading: false,
    icon: '',
    isIconLeft: true,
    isColorBg: false,
    isInverse: false,
    disabled: false,
    ariaLabel: 'Cancel',
    customClass: '',
    role: 'button'
  }

  cancelClick(event: Event): void {
    this.router.navigate(['projects']);
  }
}
